import './App.css';
import './styles/theme.css';

import About from './components/UI/About';
import Counter from './components/UI/Counter';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Hero from './components/UI/Hero';
import Portfolio from './components/UI/Portfolio';
import Services from './components/UI/Services';

function App() {
  return (
    <div className='app-container'>
      <Header />
      <Hero />
      <Counter />
      <Services />
      <About />
      <Portfolio />
      <Footer />
    </div>
  );
}

export default App;
